import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { useQuery } from "@tanstack/vue-query";
import _ from "lodash";
import { Commodity } from "seedgreen-shared/models/Commodity.js";
import { Crop } from "seedgreen-shared/models/Crop.js";
import { computed } from "vue";
const CROPS_STALE_TIME = 10 * 60 * 1000;
export function useCrops() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["crops"],
        queryFn: fetchCrops,
        staleTime: CROPS_STALE_TIME,
        select: (data) => {
            try {
                return data.map((t) => new Crop(t));
            }
            catch (error) {
                console.error("query/crops::select ERROR", error);
            }
        },
    });
    const commodities = computed(() => {
        if (!query.data.value)
            return undefined;
        const uniqueCommodities = _.uniqBy(query.data.value?.map((c) => ({
            id: c.commodityId,
            name: c.commodity,
        })), "id");
        try {
            return uniqueCommodities.map((t) => new Commodity(t));
        }
        catch (error) {
            console.error("query/crops::commodities ERROR", error);
        }
        return [];
    });
    return {
        crops: query.data,
        cropsById: computed(() => _.keyBy(query.data.value, "id")),
        commodities,
        ...query,
    };
}
async function fetchCrops() {
    const response = await seedgreenAPI.get("/Crop");
    return response.data;
}
